import * as runtime from '@/api/runtime'
import {
  ReserveContactMail,
  ReserveContactMailFromJSON,
  SearchReserveContactMailRequest,
  SearchReserveContactMailRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import { HTTPQuery } from '@/api/runtime'
import {
  BatchReserveContactMailCondition,
  BatchReserveContactMailConditionFromJSON
} from '@/api/models/batch/BatchReserveContactMailCondition'

/**
 * 検索
 */
export class BatchReserveContactMailSearchApi extends runtime.BaseAPI {
  async searchReserveContactMail(
    request: SearchReserveContactMailRequest
  ): Promise<ReserveContactMail[]> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(SearchReserveContactMailRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      `/batch/reserve/reserve-contact-mail-search`,
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReserveContactMailFromJSON)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReserveContactMailCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReserveContactMailConditionFromJSON(jsonValue)
    ).value()
  }
}
